import { api } from "@/api";
import { type IAddVoucherRequest, type IRemoveVoucherRequest } from "./types";

export const addVoucher = (data: IAddVoucherRequest): Promise<void> =>
  api.post(
    "/vouchers",
    { voucherCode: data.voucherCode },
    { headers: { jointBillServiceId: data.jointBillServiceId } },
  );

export const removeVoucher = (data: IRemoveVoucherRequest): Promise<void> =>
  api.delete(`/vouchers/${data.voucherId}`, {
    headers: { jointBillServiceId: data.jointBillServiceId },
  });
